"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _Sensor = require("@meepshop/context/lib/Sensor");

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/logo.less");

var styles = {
  "root": "meepshop-meep-ui__newMenu-logo__root",
  "logo": "meepshop-meep-ui__newMenu-logo__logo"
};

var Logo = function Logo(_ref) {
  var height = _ref.height,
      width = _ref.width;

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      storeSetting = _useContext.storeSetting;

  var _useSensorContext = (0, _Sensor.useSensorContext)(),
      isMobile = _useSensorContext.isMobile;

  var logo = (isMobile ? storeSetting === null || storeSetting === void 0 ? void 0 : storeSetting.mobileLogoUrl : storeSetting === null || storeSetting === void 0 ? void 0 : storeSetting.logoUrl) || (storeSetting === null || storeSetting === void 0 ? void 0 : storeSetting.logoUrl);
  if (!logo) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root,
    style: {
      height: height,
      width: width
    }
  }, /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: "/",
    target: "_self"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: styles.logo,
    loading: "eager",
    src: logo,
    style: {
      height: height,
      width: width,
      objectFit: height && width ? 'contain' : undefined
    },
    alt: (storeSetting === null || storeSetting === void 0 ? void 0 : storeSetting.storeName) || 'Logo'
  })));
};

var _default = Logo;
exports["default"] = _default;